<template>
  <div class="min-h-screen bg-gray-50">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div class="mb-8">
        <h1 class="text-2xl font-bold text-gray-900">Monitoring</h1>
        <nav class="mt-4">
          <ul class="flex space-x-4">
            <li>
              <router-link 
                to="/monitoring/arbitrage"
                class="px-3 py-2 rounded-md text-sm font-medium"
                :class="[$route.path === '/monitoring/arbitrage' ? 'bg-indigo-100 text-indigo-700' : 'text-gray-500 hover:text-gray-700']"
              >
                Arbitrage
              </router-link>
            </li>
            <li>
              <router-link 
                to="/monitoring/alerts"
                class="px-3 py-2 rounded-md text-sm font-medium"
                :class="[$route.path === '/monitoring/alerts' ? 'bg-indigo-100 text-indigo-700' : 'text-gray-500 hover:text-gray-700']"
              >
                Alerts
              </router-link>
            </li>
            <li>
              <router-link 
                to="/monitoring/history"
                class="px-3 py-2 rounded-md text-sm font-medium"
                :class="[$route.path === '/monitoring/history' ? 'bg-indigo-100 text-indigo-700' : 'text-gray-500 hover:text-gray-700']"
              >
                History
              </router-link>
            </li>
          </ul>
        </nav>
      </div>
      <router-view></router-view>
    </div>
  </div>
</template> 